import { Injectable } from '@angular/core';
import { ICandidate } from '@shared/interfaces/candidate.interface';
import { IFilter } from '@shared/interfaces/filter.interface';
import { IFiltersCandidate } from '@shared/interfaces/filters/filters.candidate.interface';
import { ISort } from '@shared/interfaces/sort.interface';
import { CandidatesService } from '@shared/services/candidates.service';
import { LoggerService } from '@shared/services/logger.service';
import { PaginationService } from '@shared/services/pagination/pagination.service';

@Injectable({
  providedIn: 'root'
})
export class PaginationCandidatesService extends PaginationService<ICandidate> {
  private static readonly DEFAULT_DATES: IFilter[] = [
    {
      key: 'start_date',
      value: ''
    },
    {
      key: 'end_date',
      value: ''
    }
  ];

  private static readonly DEFAULT_FILTER: IFilter = {
    label: 'FILTERS.MYSELF',
    key: 'candidates',
    value: 'scope:my'
  };

  private static readonly DEFAULT_SORT: ISort = {
    value: 'created_at',
    isReverse: true
  };

  private _filterScope: any;

  constructor(_paginable: CandidatesService, _logger: LoggerService) {
    super(_paginable, _logger);

    this.setFilter(PaginationCandidatesService.DEFAULT_FILTER);
    this.setDates(PaginationCandidatesService.DEFAULT_DATES);
    this.setSort(PaginationCandidatesService.DEFAULT_SORT);
  }

  public getFilter(): IFiltersCandidate {
    return this._filterScope;
  }

  public reset() {
    super.reset();

    this.setFilter(PaginationCandidatesService.DEFAULT_FILTER);
    this.setDates(PaginationCandidatesService.DEFAULT_DATES);
    this.setSort(PaginationCandidatesService.DEFAULT_SORT);
  }

  public setFilter(filter: Partial<IFiltersCandidate>): void {
    this._filterScope = new IFiltersCandidate(filter);
    super.setFilter(this._filterScope);
  }
}
